import {MessageBar, MessageBarButton, MessageBarType, Stack, TextField,} from "@fluentui/react";
import React, {useCallback, useState} from "react";
import {useTranslation} from "react-i18next";
import Axios from "axios";
import {useBoolean} from "@fluentui/react-hooks";
import {TitleAndContentLayout} from "./TitleAndContentLayout";
import {GetApiError} from "./ShowApiError";
import {LoadingButton} from "./LoadingButton";

export interface IPasswordSubmitModel {
    OldPassword: string;
    NewPassword: string;
    ConfirmPassword: string;
}

export const UserSettingsResetPassword = () => {
    const {t} = useTranslation();

    const [passwordSubmit, setPasswordSubmit] = useState<IPasswordSubmitModel>({
        OldPassword: "",
        NewPassword: "",
        ConfirmPassword: "",
    });
    const [Errors, SetErrors] = useState<any>();
    const [Success, SetSuccess] = useState(false);
    const [loading, {setTrue: setLoading, setFalse: setNotLoading}] =
        useBoolean(false);

    const SubmitPasswordChange = useCallback(() => {
        setLoading();
        Axios.post(`UserManagement/changepassword`, passwordSubmit)
            .then(() => {
                SetErrors({});
                setPasswordSubmit({
                    ConfirmPassword: "",
                    NewPassword: "",
                    OldPassword: "",
                });
                SetSuccess(true);
            })
            .catch((error) => {
                if (error.response.data.length) {
                    if (error.response.data[0].code == "PasswordMismatch") {
                        SetErrors({
                            OldPassword: ["Trenutna lozinka neispravna."],
                        });
                    }
                } else {
                    SetErrors(error.response.data);
                }
            })
            .finally(setNotLoading);
    }, [passwordSubmit]);

    const onChange = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string,
    ) => {
        const t = event.target as any;
        const n = t.name;
        setPasswordSubmit({...passwordSubmit, [n]: newValue});
    };

    const submitPasswordChange = (e: any) => {
        if (e) e?.preventDefault();
        SubmitPasswordChange();
    };

    return (
        <TitleAndContentLayout title={"password"} lessPadding isSubtitle pad>
            {!Success ? (
                <form onSubmit={submitPasswordChange}>
                    <Stack tokens={{childrenGap: 10}} style={{width: 250}}>
                        <TextField
                            type={"password"}
                            label={t("current_password")}
                            name={"OldPassword"}
                            autoComplete={"current-password"}
                            disabled={loading}
                            errorMessage={GetApiError<IPasswordSubmitModel>(
                                Errors,
                                "OldPassword",
                            )}
                            value={passwordSubmit?.OldPassword}
                            onChange={onChange}
                        />
                        <TextField
                            type={"password"}
                            label={t("new_password")}
                            name={"NewPassword"}
                            autoComplete={"new-password"}
                            value={passwordSubmit?.NewPassword}
                            disabled={loading}
                            errorMessage={GetApiError<IPasswordSubmitModel>(
                                Errors,
                                "NewPassword",
                            )}
                            onChange={onChange}
                        />
                        <TextField
                            type={"password"}
                            label={t("repeat_password")}
                            name={"ConfirmPassword"}
                            autoComplete={"new-password"}
                            value={passwordSubmit?.ConfirmPassword}
                            disabled={loading}
                            errorMessage={GetApiError<IPasswordSubmitModel>(
                                Errors,
                                "ConfirmPassword",
                            )}
                            onChange={onChange}
                        />
                        <LoadingButton
                            loading={loading}
                            text={t("change_password")}
                            onClick={submitPasswordChange}
                            type={"submit"}
                        />
                    </Stack>
                </form>
            ) : (
                <MessageBar
                    actions={
                        <div>
                            <MessageBarButton onClick={() => SetSuccess(false)}>
                                U redu
                            </MessageBarButton>
                        </div>
                    }
                    messageBarType={MessageBarType.success}
                    isMultiline={false}
                >
                    {t("password_changed_successfully")}
                </MessageBar>
            )}
        </TitleAndContentLayout>
    );
};
